import React, { SyntheticEvent } from 'react';
import { TextInput } from '@zapier/common-components';

type PostalCodeInputProps = {
  /** Show Error styling */
  hasError?: boolean;
  /** input id */
  id?: string;
  /** Id of label element */
  labelId?: string;
  /** Call when value is changed */
  onChange: (event: SyntheticEvent<HTMLInputElement> | string) => void;
  /** Current value */
  value: string;
};

const PostalCodeInput = ({
  hasError = false,
  labelId,
  id,
  onChange,
  value,
}: PostalCodeInputProps) => {
  return (
    <TextInput
      aria-labelledby={labelId}
      autoComplete="shipping postal-code"
      hasError={hasError}
      id={id}
      maxLength={5}
      name="addressZip"
      onChange={onChange}
      placeholder="00000"
      type="tel"
      value={value}
    />
  );
};

export default PostalCodeInput;
